import React, { Component } from 'react'
import { omit, pick } from 'lodash'
import { message, Select } from 'antd'
import ClaimsApi from '../../../api/People/Claims'
import Claims from './Claims'
import { formatQueryParams, idMaker } from '../../../modules/Utils'
import DocumentsApi from '../../../api/Documents'
import { compose } from 'recompose'
import withUrlFetch from '../../../elements/Select/withUrlFetch'
import withSpinning from '../../../elements/HOC/withSpinning'
import withSort from '../../../elements/HOC/withSort'
import CustomSelect from '../../../elements/Select/CustomSelect'
import withSubDropdown from '../../../elements/HOC/withSubDropdown'
import { MODAL_TYPE_NEW } from '../../../elements/Hooks/useModalData'

const ids = idMaker()
export const CLAIM_MANAGER = 'manager'
class ClaimsCont extends Component {
  state = {
    submitting: false,
    claim: {},
    claimItemList: [],
    actions: [],
    claimItem: {},
    SalesSelect: Select,
    ReqGroupSelect: Select,
    LinesSelect: Select,
  }
  api = new ClaimsApi()
  docsApi = new DocumentsApi()

  componentDidMount() {
    this.fetch()
  }

  fetch = async () => {
    try {
      this.setState({
        fetching: true,
      })
      let list = []
      if (this.props.option === CLAIM_MANAGER)
        list = await this.api.listByManager({ claimant: this.props.member._id })
      else
        list = await this.api.list(
          this.props.option === 'personal' && { claimant: this.props.member._id }
        )
      this.setState({
        fetching: false,
        list,
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ fetching: false })
    }
  }
  fetchClaim = async (key) => {
    try {
      this.setState({
        fetchingClaim: true,
      })
      const claim = await this.api.get(key)

      let actions = await this.docsApi.actions('claims', claim.status)
      actions = actions.filter((a) => a.key !== 'update' && a.key !== 'remove')
      const lines = claim.lines.map((line) => ({
        ...line,
        key: ids.next().value,
      }))
      this.setState({
        fetchingClaim: false,
        claimItemList: lines,
        claim,
        actions,
      })
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ fetchingClaim: false })
    }
  }
  onShowClaim = async (e, claim = {}, modalType = MODAL_TYPE_NEW, key) => {
    this.setState({
      visible: true,
      modalType,
      claimItemList: [],
      claim,
    })
    if (key) await this.fetchClaim(key)
  }
  onCancelClaim = () => {
    this.setState({
      visible: false,
    })
  }
  submit = async () => {
    let claim = await this.checkClaimForm()
    claim.lines = this.state.claimItemList
    this.setState({ submitting: true })
    try {
      claim = omit(claim, ['key'])
      if (this.props.option === 'personal') claim.claimant = { _id: this.props.member._id }
      await this.api.create(claim)
      this.setState({ submitting: false })
      this.onCancelClaim()
      this.fetch()
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  update = async () => {
    let claim = await this.checkClaimForm()
    claim.lines = this.state.claimItemList
    this.setState({ submitting: true })
    try {
      await this.api.update(claim)
      this.setState({ submitting: false })
      this.onCancelClaim()
      this.fetch()
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
      this.setState({ submitting: false })
    }
  }
  checkClaimForm = () => {
    return new Promise((res, rej) => {
      this.formRef.current.validateFields((err, values) => {
        if (!err) {
          const claim = Object.assign({}, pick(this.state.claim, ['_id', '_rev', '_key']), values)
          res(claim)
        }
      })
    })
  }

  remove = async () => {
    try {
      this.setState({ removing: true })
      const claims = this.state.claim
      await this.api.remove(pick(claims, ['_key', '_rev', '_id']))
      await this.fetch()
      this.setState({ removing: false, visible: false })
    } catch (e) {
      message.error(e.errorMessage)
      this.setState({ removing: false })
    }
  }
  handleOps = async (operation, claim) => {
    if (['revise', 'approve'].includes(operation)) {
      try {
        this.setState({ fetchingClaim: true })
        await this.api.operation(operation, pick(claim, ['_key', '_rev', '_id']))
        this.setState({ fetchingClaim: false })
        this.onCancelClaim()
        this.fetch()
      } catch (e) {
        message.error(e.errorMessage)
        this.setState({ fetching: false })
      }
    }
  }

  onShowClaimItem = async (e, claimItem = {}, modalItemType = MODAL_TYPE_NEW) => {
    this.setState({
      visibleClaimItem: true,
      claimItem,
      modalItemType,
    })
  }
  onCancelClaimItem = () => {
    this.setState({
      visibleClaimItem: false,
    })
  }
  submitClaimItem = async () => {
    let claimItems = await this.checkClaimItemForm()
    this.setState({ submitting: true })
    claimItems.key = ids.next().value
    this.setState({ claimItemList: [...this.state.claimItemList, claimItems] })
    this.setState({ submitting: false })
    this.onCancelClaimItem()
  }
  removeClaimItem = async (key) => {
    this.setState({ removingClaimItems: true })
    let newData = [...this.state.claimItemList]
    newData = newData.filter((item) => key !== item.key)
    this.setState({ claimItemList: newData })
    this.onCancelClaimItem()
    this.setState({ removingClaimItems: false })
  }
  updateClaimItem = async (key) => {
    let updatedClaimItem = await this.checkClaimItemForm()
    const { claimItemList } = { ...this.state }
    let claiming = claimItemList.findIndex((b) => b.key === key)
    updatedClaimItem.key = key
    claimItemList.splice(claiming, 1, updatedClaimItem)
    const newClaimItem = [...claimItemList]
    this.setState({ claimItemList: newClaimItem })
    this.onCancelClaimItem()
  }
  checkClaimItemForm = () => {
    return new Promise((res, rej) => {
      this.formItemRef.current.validateFields((err, values) => {
        if (!err) {
          res(values)
        }
      })
    })
  }

  onChangeMAC = (activity) => {
    let SalesSelect = Select
    let url
    if (activity) {
      url =
        `sales?select=_id,code` +
        formatQueryParams('activity', activity) +
        formatQueryParams('isClaim', 'true')
      SalesSelect = compose(
        withUrlFetch({
          name: 'sales',
          url: url,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSort
      )(CustomSelect)
    }
    this.formRef.current.resetFields(['sales._id'])
    this.setState({ activity, SalesSelect, url })
  }

  onChangeSales = (sales) => {
    let ReqGroupSelect = Select
    const url = sales + '/reqgroup'
    if (sales) {
      ReqGroupSelect = compose(
        withUrlFetch({
          name: 'reqgroup',
          url: url,
          cache: true,
          forceFetch: true,
        }),
        withSpinning,
        withSort
      )(CustomSelect)
    }
    this.setState({ sales, ReqGroupSelect, url })
  }
  onChangeReq = (reqgroup) => {
    let LinesSelect = Select
    const url = reqgroup
    if (reqgroup) {
      LinesSelect = compose(
        withUrlFetch({
          name: 'reqgroup',
          url: url,
          cache: true,
          forceFetch: true,
        }),
        withSubDropdown({ name: 'lines' }),
        withSpinning,
        withSort
      )(CustomSelect)
    }
    this.formItemRef.current.resetFields(['line._id'])
    this.setState({ reqgroup, LinesSelect, url })
  }
  formItemRef = React.createRef()
  formRef = React.createRef()

  render() {
    const { option, member } = this.props
    return (
      <Claims
        option={option}
        member={member}
        {...this.state}
        {...pick(this, [
          'onShowClaim',
          'onCancelClaim',
          'onChangeMAC',
          'onChangeSales',
          'onChangeReq',
          'submit',
          'update',
          'remove',
          'formRef',
          'fetch',
          'fetchClaim',
          'onShowClaimItem',
          'onCancelClaimItem',
          'submitClaimItem',
          'removeClaimItem',
          'updateClaimItem',
          'formItemRef',
          'handleOps',
        ])}
      />
    )
  }
}

ClaimsCont.propTypes = {}
ClaimsCont.defaultProps = {}

export default ClaimsCont
